import { action } from '@ember/object';
import { getSingleValueForTasField } from 'tio-common/utils/tuition-assistance/fields';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import { t, type IntlService } from 'ember-intl';
import Badge from 'tio-ui/components/badge';
import Component from '@glimmer/component';
import type TasProgramInstanceModel from 'tio-common/models/tas-program-instance';

export interface ProgramDescriptionSignature {
  Args: {
    instance: TasProgramInstanceModel;
  };
}

export default class ProgramDescription extends Component<ProgramDescriptionSignature> {
  @service declare intl: IntlService;

  get typeClassification() {
    return this.args.instance.typeClassification;
  }

  get isTypeTwoOrThreeProgram() {
    return (
      this.typeClassification === 'TAS.ProgramType.2' ||
      this.typeClassification === 'TAS.ProgramType.3'
    );
  }

  get programInstanceRoute() {
    return !!this.typeClassification
      ? 'authenticated.tas.programs.show'
      : 'authenticated.tuition-assistance.programs.instance';
  }

  @action
  estimatedStartDate(instance: TasProgramInstanceModel) {
    const startDate = getSingleValueForTasField(
      'ESTIMATED_PROGRAM_BEGIN',
      instance.fields
    ) as string;
    const formattedDate = this.intl.formatDate(startDate, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    if (startDate) {
      return formattedDate;
    } else {
      return '';
    }
  }

  <template>
    <div class="flex justify-between items-start">
      <div>
        <p class="font-medium flex items-center gap-x-2">
          {{#if this.isTypeTwoOrThreeProgram}}
            <p class="font-semibold text-lg">
              {{@instance.programName}}
            </p>
          {{else}}
            <LinkTo
              @route={{this.programInstanceRoute}}
              @model={{@instance.id}}
              class="font-semibold text-lg text-ocean-600 hover:underline"
            >
              {{@instance.programName}}
            </LinkTo>
          {{/if}}
          <Badge @intent={{@instance.badgeIntent}}>
            {{@instance.badgeLabel}}
          </Badge>
        </p>
        <p class="font-medium">{{@instance.institutionName}}</p>
        {{#if (this.estimatedStartDate @instance)}}
          <p class="text-sm">
            <span class="font-semibold">{{t "start_date"}}</span>
            {{this.estimatedStartDate @instance}}
          </p>
        {{/if}}
      </div>
    </div>
  </template>
}
